const enum ItemSourceEnum {
  Product = 1,
  Cart = 2,
  Order = 3,
}

export default ItemSourceEnum;
